<div class="ya-bottomsheet-container ya-typography">
  <ya-bottomsheetclosebottom [bottomSheetRef]="bottomSheetRef"></ya-bottomsheetclosebottom>
  <div class="ya-bottomsheet-content-center">
    <h2 langkey="phRemoteOrder_Change_Service_Time_Title">
    </h2>
    <div class="content-container">
      <ng-container *ngIf="!isClosed; then newTimeTemplate else closedTemplate"></ng-container>
      <ng-template #newTimeTemplate>
        <span [innerHTML]="timeExpiredLabel(dialogData.selectedServiceTime)"></span>
        <div class="selection">
          <div class="ya-input-container-flexwidth">
            <ng-container *ngIf="serviceOpenTime$|async; let openTimes">
              <select class="ya-input-text requestServiceTime"
                (change)="setRequestServiceTime($event.currentTarget.value)">
                <ng-container *ngFor="let serviceTime of openTimes; let index = index">
                  <option [value]="index" [selected]=" isTimeSelected(serviceTime,newServiceTime)">
                    {{serviceTime.display}}</option>
                </ng-container>
              </select>
            </ng-container>
            <div class="inline-icon" inlineSVG="hypersoft-pfeil-unten-voll.svg"></div>
          </div>
        </div>
      </ng-template>
      <ng-template #closedTemplate>
        <span langkey="phRemoteOrder_Change_Service_Time_Closed"></span>
      </ng-template>
    </div>
    <div class="buttonscontainer">
      <div class="ya-button-group-wrapper">
        <div class="ya-button-group-container">
          <ng-container *ngIf="!isClosed">
            <div class="ya-button-container">
              <button mat-flat-button (click)="confirm()">
                <span langkey="phNewOrderTimeDialog_Button_NewTime"></span>
              </button>
            </div>
          </ng-container>
          <div class="ya-button-container">
            <button mat-flat-button (click)="cancel()">
              <span langkey="phRemoteOrder_Change_Service_Time_Cancel_Btn"></span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>